var map = {
	"./locales/en.json": 97,
	"./locales/es.json": 98
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;


//////////////////
// WEBPACK FOOTER
// ./src/data ^\.\/.*\.json$
// module id = 43
// module chunks = 1